import * as React from 'react';
import { Input as TextInput } from '../../../components/ui';

import {RadioGroupContainer} from './PlanFormComponent.style';
import {Card, RadioGroup} from '../../elements';
import Select from '../../elements/Select';

import {PlanContext, usePlanContext} from '../../context/PlanContext';
import { Controller, useFormContext } from 'react-hook-form';
import { PlanFormValues } from './PlanFormInfo.type';


const BILLING_TRIGGER = [
  {
    label: 'Ao iniciar o plano (pré-pago)',
    value: 'inicio_do_periodo'
  },
  {
    label: 'Após o período (pós-pago)',
    value: 'fim_do_periodo'
  },
  {
    label: 'Dia fixo do mês',
    value: 'dia_do_mes'
  },
];

const TRIGGER_DAY_LABEL = {
  inicio_do_periodo: 'Dias após iniciar o plano',
  fim_do_periodo: 'Núm. de dias após vender o plano',
  dia_do_mes: 'Dia do mês',
}

export function PlanFormPaymentComponent() : JSX.Element {

  const {
    errors,
    plan,
    handleChange,
  } = usePlanContext();

  const form = useFormContext<PlanFormValues>();

  const planType = form.watch('planType');
  const billingTriggerType = form.watch('billingTriggerType');
  return(
      <div className="row">
        <div className="col s12">
          <Card title='Informações financeiras'>
            <div className="row">
              <div className={`col s12 ${plan.recurrence !== '' ? 'm6' : ''}`}>
                <RadioGroupContainer>
                  <Controller
                    name="recurrence"
                    control={form.control}
                    render={({ field }) => (
                      <RadioGroup
                        {...field}
                        ref={undefined}
                        label='Recorrência do plano'
                        
                        options={[
                          {
                            label: 'Nenhuma',
                            value: ''
                          },
                          {
                            label: 'Mês',
                            value: 'month'
                          },
                          {
                            label: 'Dia',
                            value: 'day'
                          },
                          {
                            label: 'Semana',
                            value: 'week'
                          },
                        ]}
                        value={field.value}
                        withGap
                      />
                    )}
                  />
                  </RadioGroupContainer>
              </div>
            </div>
            
            <div className="row">
            {(plan.recurrence !== '' || planType === 'checkin') &&(
              <Controller
                name="recurrenceValue"
                control={form.control}
                render={({ field }) => (
                    <TextInput 
                      s={3}
                      m={2}
                      {...field}
                      ref={undefined}
                      label="Quantidade" 
                      type='tel'
                      error={errors.recurrenceValue} 
                      inputClassName={errors?.recurrenceValue ? 'invalid' : ' '} 
                    />
                  )}
                />
              )}
              <Controller
                name="value"
                control={form.control}
                render={({ field }) => (
                    <TextInput 
                      s={3}
                      {...field}
                      ref={undefined}
                      label="Valor (R$)" 
                      type='tel'
                      error={errors.value} 
                      inputClassName={errors?.value ? 'invalid' : ' '} 
                    />
                  )}
                />
              {plan?.value && Number(plan?.value) > 0 && (
                <Controller
                  name="installments"
                  control={form.control}
                  render={({ field }) => (
                    <TextInput 
                      s={4}
                      m={2}
                      {...field}
                      ref={undefined}
                      label="Máx. parcelas" 
                      type='tel'
                      error={errors.installments} 
                      inputClassName={errors?.installments ? 'invalid' : ' '} 
                    />
                  )}
                />
            )}
            </div>

            <div className="row">
              <div className="col s12">
                <div className="flow-text"><small>Recorrência da Cobrança</small></div>
              </div>
            </div>
            <div className="row">
              <div className="col s12 m4" style={{marginBottom: 20}}>
                <Controller
                  name="billingTriggerType"
                  control={form.control}
                  render={({ field }) => (
                    <Select
                      {...field}
                      onChange={(option: any) => {
                        field.onChange(option?.value ?? '');
                      }}
                      value={BILLING_TRIGGER.find((opt) => opt.value === field.value)}
                      isMulti={false}
                      options={BILLING_TRIGGER}
                      placeholder={'Ciclo de cobranças'}
                      selectType="select2"
                    />
                  )}
                />
              </div>
              <Controller
                name="billingTriggerDay"
                control={form.control}
                render={({ field }) => (
                    <TextInput
                      s={6}
                      m={4}
                      {...field}
                      ref={undefined}
                      label={TRIGGER_DAY_LABEL[billingTriggerType as keyof typeof TRIGGER_DAY_LABEL]}
                      type='tel'
                      error={errors.billingTriggerDay} 
                      inputClassName={errors?.billingTriggerDay ? 'invalid' : ' '} 
                    />
                  )}
                />
              <Controller
                name="cycles"
                control={form.control}
                render={({ field }) => (
                  <TextInput
                    s={6}
                    m={4}
                    {...field}
                    ref={undefined}
                    label={'Limite de renovações'}
                    type='tel'
                    error={errors.cycles} 
                    inputClassName={errors?.cycles ? 'invalid' : ' '} 
                  />
                )}
              />
            </div>
          </Card>
        </div>
      </div>
  )
}